
import * as THREE from 'three';
import { ThreeView } from '../../../view3d/webcad/View3dWebCad';
import { Wall } from '../../jsonParse';
import { PointInfo } from '../../WalltoFittingInfo';

export class OffsetCalculate {

    public minY = Infinity;

    constructor() {

    }    

    // 高さ方向のoffset値求める
    public offsetY(height: number, matrix: number[]): void {
        const halfHeight = height / 2;
        const offset = new THREE.Vector3(matrix[12], matrix[13], matrix[14]);
        this.minY = Math.min(this.minY, offset.y - halfHeight);
    }

    // 補正回転角を取得
    public getRadiun(walls: Wall[]): number {
        const rad = this.getAxis(walls);
        return this.calculateAverage(rad);
    }

    // 軸ベクトルを表示
    public vector(walls: Wall[]) {
        const ave = this.getRadiun(walls);
        {
            const dir = new THREE.Vector3(1, 0, 0).applyAxisAngle(new THREE.Vector3(0, 1, 0), ave);
            const arrow = new THREE.ArrowHelper(dir, new THREE.Vector3(0,0,0), 1, 0x00FF00);
            ThreeView.get().wcItemmgr.addOtherShapes(arrow);
        }
        const vec = new THREE.Vector3(0,0,0);
        const vectors = this.getAxis_(walls);
        vectors.forEach((v) => {
            vec.add(v);
        });
        const dir = vec.normalize();
        const arrow = new THREE.ArrowHelper(dir, new THREE.Vector3(0,0,0), 1, 0xFFFF00);
        ThreeView.get().wcItemmgr.addOtherShapes(arrow);
    }
    
    // global 1,0,0 ±45度以内 の x,z軸取得
    private getAxis(walls: Wall[]): number[] {
        const array: number[] = [];
        for (let i = 0; i < walls.length; i++) {
            const wall = walls[i];
            const transform = wall.transform;
            const X = new THREE.Vector3(transform[0], transform[1], transform[2]);
            const Z = new THREE.Vector3(transform[8], transform[9], transform[10]);
            const result = this.check(X, Z);
            // undefined なら異常値
            console.assert(result != null, '異常値');
            if (result != null) array.push(result);
        }
        return array;
    }
    private getAxis_(walls: Wall[]): THREE.Vector3[] {
        const array: THREE.Vector3[] = [];
        for (let i = 0; i < walls.length; i++) {
            const wall = walls[i];
            const transform = wall.transform;
            const X = new THREE.Vector3(transform[0], transform[1], transform[2]);
            const Z = new THREE.Vector3(transform[8], transform[9], transform[10]);
            const result = this.check_(X, Z);
            // undefined なら異常値
            console.assert(result != null, '異常値');
            if (result != null) array.push(result);
        }
        return array;
    }

    /**
     * pointInfoのリストからglobal 1,0,0 ±45度以内 の x,z軸取得する
     * @param pointList
     * @returns
     */
    public getAxisFromPointInfo(pointList: PointInfo[]): number[] | null {
        const results: THREE.Vector3[] = [];
        for (let i = 0; i < pointList.length; i+=2) {
            const p1 = pointList[i].point.clone();
            const p2 = pointList[(i + 1)%pointList.length].point.clone();
            const p = p2.clone().sub(p1);

            const vec3_1 = new THREE.Vector3(p.x, 0, p.z).clone().normalize(); // xz平面に変換
            const orthogonal = this.getOrthogonalVector(vec3_1);
            if (orthogonal == null) return null;
            const vec3_2 = orthogonal.clone().normalize(); // xz平面に変換された直交ベクトル
            if (vec3_2 == null) return null; 
            const result = this.check_(vec3_1, vec3_2);      
            console.assert(result != null, '異常値'); // undefined なら異常値
            if (result == null) return null;

            results.push(result);
        }
        return results.map((vec: THREE.Vector3) => {
            return vec.clone().angleTo(new THREE.Vector3(1, 0, 0));
        });
    }

    /**
     * ベクトルに直交するベクトルを求める(xz平面)
     * @param vec3 
     * @returns 
     */
    private getOrthogonalVector(vec3: THREE.Vector3) {
        // もしベクトルvがゼロベクトルだった場合、直交ベクトルもゼロベクトル
        if (vec3.x === 0 && vec3.z === 0) return null;

        // ベクトルvの要素を入れ替えて直交ベクトルを作成
        return new THREE.Vector3(-vec3.z, 0, vec3.x);
    }  


    // 45度以内のベクトルをチェックしてVector3を返す
    private check_(X: THREE.Vector3, Z: THREE.Vector3): THREE.Vector3 | null {
        const globalX = new THREE.Vector3(1, 0, 0);
        const reverseX = new THREE.Vector3(-X.x, -X.y, -X.z);
        const reverseZ = new THREE.Vector3(-Z.x, -Z.y, -Z.z);
        
        if (1/Math.sqrt(2) < X.clone().dot(globalX) && X.clone().dot(globalX) < 1) {
            return X;
        }
        if (1/Math.sqrt(2) < Z.clone().dot(globalX) && Z.clone().dot(globalX) < 1) {
            return Z;
        }
        if (1/Math.sqrt(2) < reverseX.clone().dot(globalX) && reverseX.clone().dot(globalX) < 1) {
            return reverseX;
        }
        if (1/Math.sqrt(2) < reverseZ.clone().dot(globalX) && reverseZ.clone().dot(globalX) < 1) {
            return reverseZ;
        }

        // globalXと等しかったら
        if (globalX.clone().equals(X) || globalX.clone().equals(Z) || globalX.clone().equals(reverseX) || globalX.clone().equals(reverseZ)) {
            return globalX;
        }

        return null;
    }

    // 45度以内のベクトルをチェックしてradiun返す
    public check(X: THREE.Vector3, Z: THREE.Vector3): number | null {
        const globalX = new THREE.Vector3(1, 0, 0);
        const reverseX = new THREE.Vector3(-X.x, -X.y, -X.z);
        const reverseZ = new THREE.Vector3(-Z.x, -Z.y, -Z.z);
        if (1/Math.sqrt(2) < X.dot(globalX) && X.dot(globalX) < 1) {
            const flip = globalX.clone().cross(X).y > 0 ? 1 : -1;
            return X.angleTo(globalX) * flip;
        }
        if (1/Math.sqrt(2) < Z.dot(globalX) && Z.dot(globalX) < 1) {
            const flip = globalX.clone().cross(Z).y > 0 ? 1 : -1;
            return Z.angleTo(globalX) * flip;
        }
        if (1/Math.sqrt(2) < reverseX.dot(globalX) && reverseX.dot(globalX) < 1) {
            const flip = globalX.clone().cross(reverseX).y > 0 ? 1 : -1;
            return reverseX.angleTo(globalX) * flip;
        }
        if (1/Math.sqrt(2) < reverseZ.dot(globalX) && reverseZ.dot(globalX) < 1) {
            const flip = globalX.clone().cross(reverseZ).y > 0 ? 1 : -1;
            return reverseZ.angleTo(globalX) * flip;
        }
        return null;
    }

    // 平均値
    public calculateAverage(radiuns: number[]): number {
        let sum = 0;
        radiuns.forEach((rad: number) => sum += rad);
        return sum / radiuns.length;
    }

    /**
     * 数値のリストの中央値を計算
     * @param numbers 
     * @returns 
     */
    public calculateMedium(numbers: number[]): number {
        // 数値を昇順にソート
        const sortedNumbers = numbers.slice().sort((a, b) => {
            return a - b;
        });
        
        const length = sortedNumbers.length;
        
        let median;
        if (sortedNumbers.length % 2 === 0) {
            // 要素数が偶数の場合、中央の2つの値の平均を取る
            median = (sortedNumbers[length / 2 - 1] + sortedNumbers[length / 2]) / 2;
        } else {
            // 要素数が奇数の場合、中央の値を取る
            median = sortedNumbers[Math.floor(length / 2)];
        }
        
        return median;
    }

    /**
     * 最頻値を求める関数
     * @param numbers 
     * @returns 
     */
    public calculateMode(numbers: number[]): number {
        // データを出現回数ごとにグループ化する
        const frequencyMap = {};
        for (let i = 0; i < numbers.length; i++) {
          const number = numbers[i];
          frequencyMap[number] = (frequencyMap[number] || 0) + 1;
        }
      
        // 最頻値の出現回数を特定
        let maxFrequency = 0;
        for (const number in frequencyMap) {
          if (frequencyMap.hasOwnProperty(number)) {
            const frequency = frequencyMap[number];
            if (frequency > maxFrequency) {
              maxFrequency = frequency;
            }
          }
        }
      
        // 最頻値を取得
        for (const number in frequencyMap) {
          if (frequencyMap.hasOwnProperty(number)) {
            const frequency = frequencyMap[number];
            if (frequency === maxFrequency) {
                return Number(number);
            }
          }
        }
      
    }
}